import React, { Component } from 'react';
import PropTypes from 'prop-types';

import getAuth from '../../helpers/get-auth';
import isBlankString from '../../helpers/is-blank-string';

import CardForm from './card-form';
import Popup from '../popup';

class CardActivate extends Component {
  static propTypes = {
    route: PropTypes.shape({
      user: PropTypes.string,
      activate: PropTypes.string,
    }).isRequired,
  };

  state = {
    loading: true,
    data: false,
    sendData: false,
    short: false,
    step: 0,
    error: null,
    birthday: false,
  };

  // Получаем текущего пользователя
  componentDidMount() {
    const {
      route: { user },
    } = this.props;
    const self = this;

    let headers = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    };

    if (process.env.NODE_ENV != 'dev') {
      headers.credentials = 'include';
    } else {
      headers.headers.authorization = getAuth();
    }

    fetch(user, headers)
      .then(response => response.json())
      .then(json => {
        // console.log(json);

        if (json.status == 'success') {
          this.setState({
            loading: false,
            data: json.data || {},
            birthday: json.data && json.data.birthday,
            short: this.defineShortForm(json.data),
          });
        } else if (json.status == 'error') {
          if (json.errors.code == 14) {
            this.setState({
              loading: false,
              data: {},
              short: false,
            });
          } else {
            this.setState({
              loading: false,
            });
            alert(json.errors.message);
          }
        }
      });
  }

  // Показываем большую или маленькую форму
  defineShortForm(data) {
    if (!data) return false;

    // function checkChildren() {
    // 	let childFill = true;

    // 	for (let i = 0, len = data.childs.length; i < len; i++) {
    // 		let child = data.childs[i];

    // 		if (isBlankString([child.birthday, child.name])) {
    // 			short = false;
    // 			break;
    // 		}

    // 		if (child.gender != 0 && child.gender != 1) {
    // 			short = false;
    // 			break;
    // 		}
    // 	}
    // }

    let short = true;

    if (isBlankString([data.birthday, data.email, data.name])) {
      short = false;
    }
    if (data.gender != 0 && data.gender != 1) {
      short = false;
    }
    if (!data.phone || `${data.phone}`.length < 11) {
      short = false;
    }
    // if (data.childs && checkChildren()) short = false;

    return short;
  }

  // Готовим данные на отправку
  prepareData(form) {
    const data = $(form).serializeArray();

    if (!data) return data;

    let formData = new FormData();

    data.forEach(item => {
      if (!isBlankString(item.value)) {
        formData.append(item.name, item.value);
      }
    });

    return formData;
  }

  // Отправляем данные
  confirm = form => {
    const { step } = this.state;
    const {
      route: { activate },
    } = this.props;

    let data = this.prepareData(form);

    let headers = {
      method: 'POST',
      body: data,
      headers: {},
    };

    if (process.env.NODE_ENV != 'dev') {
      headers.credentials = 'include';
    } else {
      headers.headers.authorization = getAuth();
    }

    this.setState({
      sendData: true,
      error: null,
    });

    // for (let pair of data.entries()) {
    // 	console.log(pair[0]+ ', ' + pair[1]);
    // }

    fetch(activate, headers)
      .then(response => response.json())
      .then(json => {
        // console.log(json);

        if (json.status == 'success') {
          this.setState({
            sendData: false,
            step: 2,
            error: null,
          });
        } else {
          if (step == 0) {
            if (json.errors.code == 14) {
              this.setState({
                step: 1,
                error: null,
                sendData: false,
              });
            } else {
              this.setState({
                error: json.errors.message,
                sendData: false,
              });
            }
          } else if (step == 1) {
            this.setState({
              error: json.errors.message,
              sendData: false,
            });
          } else {
            this.setState({
              sendData: false,
              error: null,
            });
          }
        }
      })
      .catch(error => {
        // console.warn(error);

        this.setState({
          sendData: false,
          error: null,
        });
      });
  };

  render() {
    const {
      loading,
      data,
      error,
      sendData,
      short,
      step,
      birthday,
    } = this.state;

    if (loading || !data)
      return (
        <div className="popup popup--loading">
          <button className="popup__close" type="button">
            <svg viewBox="0 0 18 18" width="18" height="18">
              <path d="M15.5 17.6l-6.5-6.5-6.5 6.5c-.6.6-1.5.6-2.1 0-.6-.6-.6-1.5 0-2.1l6.5-6.5-6.5-6.5c-.6-.6-.6-1.5 0-2.1.6-.6 1.5-.6 2.1 0l6.5 6.5 6.5-6.5c.6-.6 1.5-.6 2.1 0 .6.6.6 1.5 0 2.1l-6.5 6.5 6.5 6.5c.6.6.6 1.5 0 2.1-.3.3-.6.4-1 .4s-.8-.2-1.1-.4z"></path>
            </svg>
          </button>
        </div>
      );

    if (step == 2)
      return (
        <Popup
          type="alert"
          status="success"
          title="Отлично!"
          message="Карта успешно активирована. Теперь вы сможете оплачивать заказы бонусами."
          button="Назад"
        />
      );

    return (
      <CardForm
        data={data}
        loading={sendData}
        confirm={this.confirm}
        short={short}
        step={step}
        error={error}
        birthday={birthday}
      />
    );
  }
}

export default CardActivate;
